var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show_report
    ? _c("report-management-page", {
        attrs: { module: "asset-governance", is_admin: _vm.is_admin },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }